import { motion } from "framer-motion";
import { Target, Compass, Briefcase, GraduationCap } from "lucide-react";
import AuditField from "./AuditField";

export default function BlocObjectifs({ data }) {
  const p = data.projets || {};
  const o = data.objectifs || [];

  return (
    <motion.section 
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      {/* Objectifs exprimés du foyer */}
      <div className="workspace-card p-6 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm space-y-4">
        <div className="flex items-center gap-2.5 pb-3 border-b border-workspace">
          <Target className="w-5 h-5 text-secondary" />
          <h2 className="text-lg font-bold text-primary">Objectifs Patrimoniaux du Foyer</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3.5">
          <AuditField label="Enveloppe Globale à Investir" value={data.enveloppe ? `${Number(data.enveloppe).toLocaleString("fr-FR")} €` : "—"} className="font-bold text-primary" />
          <AuditField label="Horizon d'Investissement" value={data.horizonInvestissement || "Moyen terme (5 - 8 ans)"} />
          <AuditField label="Capacité d'Épargne Mensuelle" value={data.epargneMensuelle ? `${Number(data.epargneMensuelle).toLocaleString("fr-FR")} €/mois` : "—"} />
          <AuditField label="Besoins de Prévoyance" value={data.besoins || "Protection de la famille et des enfants"} className="col-span-1 sm:col-span-2" />
          <AuditField label="Priorités Exprimées" value={o.length ? o.join(", ") : "Valorisation du capital, optimisation fiscale, transmission"} className="col-span-1 sm:col-span-3" />
        </div>
      </div>

      {/* Projets de Vie & Connaissances */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Projets Personnels et Professionnels */}
        <div className="workspace-card p-6 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm space-y-4">
          <div className="flex items-center gap-2 pb-3 border-b border-workspace">
            <Compass className="w-4 h-4 text-secondary" />
            <h3 className="text-base font-bold text-primary">Projets Personnels & Professionnels</h3>
          </div>

          <div className="space-y-3">
            <AuditField label="Projets Familiaux (Privé)" value={p.personnel?.join(', ') || "Achat résidence, études des enfants"} />
            <AuditField label="Projets Professionnels (Sociétés)" value={p.professionnel?.join(', ') || "Cession d'entreprise, création de holding"} />
          </div>
        </div>

        {/* Profil Investisseur & Risque */}
        <div className="workspace-card p-6 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm space-y-4">
          <div className="flex items-center gap-2 pb-3 border-b border-workspace">
            <GraduationCap className="w-4 h-4 text-secondary" />
            <h3 className="text-base font-bold text-primary">Connaissances & Appétence Risque</h3>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <AuditField label="Culture Financière" value={data.connaissancesFinancieres || data.connaissanceFinanciere || "Intermédiaire"} />
            <AuditField label="Culture Juridique & Fiscale" value={data.connaissancesJuridiquesFiscales || "Bonne"} />
            <AuditField label="Profil de Risque MIF 2" value={data.profilInvestisseur || data.toleranceRisque || "Équilibré"} className="col-span-2 font-bold text-secondary" />
          </div>
        </div>
      </div>
    </motion.section>
  );
}
